import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';
// import './carnival.css';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ReactTooltip from "react-tooltip";

const CarnivalForm = ({
  handleValue,
  prefilledData
}) => {
    const inputs = {
        start_date: '',
        start_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        end_date: '',
        end_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        subject: '',
    };
    // const [inputList, setInputList] = useState([{ name:"",image_url: "", position: ""}]);
    const [formData, setData] = useState(inputs);
    const [infraId, setInfraId] = useState(0);
    const [projectName, setProjectName] = useState();
    const [infraIdToCheck, setInfraIdToCheck] = useState();
    const [minDateIndex, setMinDateIndex] = useState(null);

    const handleStartDate = (date, dateString) => {
        setData({ ...formData, start_date: dateString });
        setMinDateIndex(dateString);
    };

    const handleEndDate = (date, dateString) => {
        setData({ ...formData, end_date: dateString });
    };

    useEffect(() => {
        if (prefilledData?.carnival !== null && prefilledData?.carnival !== undefined) {
            const {
                id,
                infra_id,
                name,
                start_date,
                start_time,
                end_date,
                end_time,
                project_name,
                parent_id
            } = prefilledData?.carnival;
            setTimeout(() => {
                setInfraIdToCheck(infra_id);
                setInfraId(infra_id);
                setProjectName(project_name);
                setData({ ...formData,
                    subject: name,
                    carnival_id: id,
                    start_date: (parent_id != null) ? start_date : null,
                    end_date: (parent_id != null) ? end_date : null,
                    start_time: (parent_id != null) ? start_time : null,
                    end_time: (parent_id != null) ? end_time : null,
                    // is_update: (parent_id != null) ? true : null
                });
            }, 500);
            
        }
    }, [prefilledData])

  const handleMeetingData = () => {
    if (
        formData.start_date !== '' &&
        formData.end_date !== '' &&
        formData.start_time !== '' &&
        formData.end_time !== '' &&
        formData.carnival_id !== ''
    ) {
        handleValue(formData);
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData]);
  
    function onStartChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, start_time: `${hour}:${minute}` });
    }
    function onEndChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, end_time: `${hour}:${minute}` });
    }
    
  return (
    <FormSection title={localization.carnivalDetails}>
        <div className="row">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectId}
                    value={infraId}
                    disabled
                />
            </div>
        </div>
        
        {infraId !== 0 ? (
        <>
        <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectName}
                    value={projectName}
                    disabled
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={formData.subject}
                    label={localization.societyName}
                    errorMsg={localization.enterSocietyName}
                    type="text"
                    maxLength={20}
                    required
                    isStarRequired={true}
                    fullWidth
                    disabled
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.start_date ? new Date(formData?.start_date) : null}
                    onChange={handleStartDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={new Date()}
                    />
                    <label>
                    {localization.startDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.start_time}
                    onTimeChange={onStartChange}
                    />
                    <label>{localization.startTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.end_date ? new Date(formData?.end_date) : null}
                    onChange={handleEndDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={minDateIndex === null 
                        ? new Date()
                        : minDateIndex}
                    />
                    <label>
                    {localization.endDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.end_time}
                    onTimeChange={onEndChange}
                    />
                    <label>{localization.endTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
        </div>

        <div className="row form-group">
            
        </div>



                </>
        ) : null}

    </FormSection>
  );
};

CarnivalForm.propTypes = {};

export default CarnivalForm;
